module.exports = __webpack_public_path__ + "img/lote-terceiro.2c9cc47f.jpg";